import { useEffect } from 'react';
import { updateLoggers } from '../../../../services/loggers/errorLogger';
import { defaultTo, equals, join, pick, pickBy, pipe } from 'ramda';
import { bi } from '../../../../services/loggers/bi';
import { getSessionId } from '../../../env/getSessionId/getSessionId';
import { updateFullStoryParams } from '../../../../services/loggers/fullStoryLogger';
import { defaultMMGRSettings } from '../../../hoc/withMMGRSettings/defaultMMGRSettings';
import { useMMGRSettings } from '../../../hoc/withMMGRSettings';
import { TIncomingMMGRSettings } from '../../../hoc/withMMGRSettings/withMMGRSettings.types';
import { extractBiParams } from '../../../bi';

const pickNonDefaultSettings: (mmgrSettings: TIncomingMMGRSettings) => Partial<TIncomingMMGRSettings> = pipe(
  defaultTo({}),
  pick([
    'additionalItemAttributes',
    'canShowSelectButton',
    'canSubmitUntranscoded',
    'uploadItems',
    'uploadItemsOpen',
    'tabsList',
    'servicesList',
    'sort',
    'layout',
    'mediaType',
    'namespace',
    'initialMediaTypes',
    'restrictContent',
    'path',
    'publicMediaRoot',
    'origin',
    'openSource',
    'customData',
  ]),
  pickBy((value, key: string) => !equals(value, defaultMMGRSettings[key])),
);

export const useAnalyticsProvider = () => {
  const { mmgrSettings, latestIncomingMMGRSettings } = useMMGRSettings();

  useEffect(() => {
    const { userId, publicMediaRoot, mediaType, origin, openSource, metaSiteId } = extractBiParams(mmgrSettings);

    bi.updateDefaults({
      msid: metaSiteId,
      origin,
      source: openSource,
      context: mediaType,
      publicMediaRoot: join(',', publicMediaRoot),
      sessionId: getSessionId(),
    });

    updateFullStoryParams({ metaSiteId });
    updateLoggers({ userId, metaSiteId, mmgrSettings: pickNonDefaultSettings(latestIncomingMMGRSettings) });
  }, [mmgrSettings, latestIncomingMMGRSettings]);
};
